import Aggregation from "../Aggregation";

export class Operation {
    /*
    This is an operation ON a column. The column argument to the constructor is the column that acts as the operand.

    The class this instance belongs to is the new column where the result of the operation is stored.
     */

    constructor({column}) {
        /**
         * @type {ColumnDef} column - The definition of the column this operation applies to.
         */
        if (column instanceof Aggregation) {
            console.error("Invalid column definition provided. column=", column, "This is an aggregation, not a column.");
            throw new Error("Invalid column definition provided. This is an aggregation, not a column.");
        }
        if (column === null || !column === undefined) {
            console.error("Invalid column definition provided. column=", column);
            throw new Error("Invalid column definition provided.");
        }

        this.column = column;
        this.currValue = null;
        this.cells = [];

        if (this.column === null || this.column === undefined) {
            console.error("Invalid column definition provided. column=", this.column);
            throw new Error("Invalid column definition provided.");
        }
    }

    static typeOverride() {
        /**
         * Some columns will always have a particular type, e.g. Count will always be a NUMBER, Percentile will always
         * be a PERCENTILE, etc. If your Operation should always have a specific type, override this method
         */
        return null;
    }

    static isNumeric() {
        /**
         * This method should be overridden by subclasses to indicate if the operation is numeric. Numeric operations
         * have sortValue()s that can be used in e.g. sum, mean, divide, etc.
         * @returns {boolean} - true if the operation is numeric, false otherwise.
         */
        return false; // Default implementation, subclasses should override
    }

    static isCategorical() {
        /**
         * This method should be overridden by subclasses to indicate if the operation is categorical. Categorical
         * operations do not have sortValue()s that SHOULD NOT be used in e.g. sum, mean, divide, etc. They can still
         * be used in operations like count, count distinct, etc.
         * @returns {boolean} - true if the operation is categorical, false otherwise.
         */
        return false; // Default implementation, subclasses should override
    }

    static handlesDate() {
        /**
         * This method should be overridden by subclasses to indicate if the operation handles date values.
         * @returns {boolean} - true if the operation handles date values, false otherwise.
         */
        return false; // Default implementation, subclasses should override
    }

    aggregateRow(row) {
        // if (!row || !row.cells || isNaN(this.column.getIndex()) || row.cells.length <= this.column.getIndex()) {
        //     console.error(this.column.displayName, "has the wrong index set: ", this.column.getIndex(), "the row from which we're attempting to aggregate has", row.cells.length, "cells. Row=", row);
        //     throw new Error("Invalid row or column index.");
        // }
        if (isNaN(this.column.getIndex())) {
            console.error("Invalid column index: ", this.column.getIndex(), "for column:", this.column.displayName);
            throw new Error("Invalid column index: " + this.column.getIndex());
        }
        const cell = row.cells[this.column.getIndex()];
        if (cell === null || cell.getSortValue === undefined) {
            console.error(this.column.displayName, "has the wrong index set: ", this.column.getIndex(), "the row from which we're attempting to aggregate has", row.cells.length, "cells. Row=", row);
            throw new Error("Cell not found.");
        }
        const sortValue = cell.getSortValue();
        this.incrementAggregation(sortValue);
        this.cells.push(cell);
    }

    incrementAggregation(newValue) {
        /**
         * This method is used to aggregate a row for this operation. Subclasses should implement this method. It should
         * update this.currValue in place based on the newValue provided.
         */
        // this.currValue += (newValue || 0);
    }

    finish(globalAggregation) {
        /**
         * This method is called after all rows have been processed. Subclasses can implement this to finalize the
         * operation.
         */
        return this.currValue || 0;
    }

    static displayName() {
        /**
         * This method should return a string that represents the operation. It is used for display purposes.
         */
        return this.constructor.name;
    }

}

export default Operation;
